import { DEFAULT_IMAGE_BASE64 } from '../../../../../../utils/msc';

import styles from './index.module.scss';
import { throttle, useCart } from '../../../../../../hooks/useCart';
import { EThrottles, FlattenedProductProps } from '../../../../../../models';
import { useOnlineStatus } from '../../../../../../hooks/useOnline';

type GridListProps = {
	product: FlattenedProductProps;
};

const GridList = ({ product }: GridListProps) => {
	const { handleAddToCart } = useCart();

	const isOnline = useOnlineStatus();

	const throttleHandleAddToCart = throttle(handleAddToCart, EThrottles.click);

	delete product?.attributes?.id;

	return (
		<section
			onClick={() => throttleHandleAddToCart({ ...product, quantity: 1 })}
			className={`${styles.wrapper} d-flex`}
			style={{ width: '100%' }}
		>
			<div className={`${styles.innerWrapper} d-flex align-content-stretch p-2`} style={{ flexDirection: 'column' }}>
				<div className={`d-flex flex-fill align-item-center justify-content-center ${styles.imgBg} px-4`}>
					{!isOnline || !product?.productImage ? (
						<img style={{ height: '98px' }} alt={product?.productName} src={DEFAULT_IMAGE_BASE64} />
					) : (
						<img
							alt={product?.productName}
							src={!isOnline ? DEFAULT_IMAGE_BASE64 : product?.productImage || DEFAULT_IMAGE_BASE64}
						/>
					)}
				</div>

				<div className={`text-center px-1 my-2 ${styles.contentWrapper}`}>
					<aside className={`d-flex align-items-center justify-content-center ${styles.title}`}>
						<span className="lamp-2">{product.productName}</span>
					</aside>
					<aside className={`d-flex align-items-center justify-content-center capitalize ${styles.desc}`}>
						<span className="line-clamp-1">
							{product?.attributes ? Object.entries(product?.attributes).map(([k, v]) => `${k}, ${v}`) : null}

							{product?.attributes ? ' - ' : ''}
							{product?.description || '-'}
						</span>
					</aside>
				</div>
			</div>
		</section>
	);
};

export default GridList;
